import * as React from 'react';
import { AppContext, IAppContext } from './contexts/AppContext';

import './Ribbon.scss';

//@ts-ignore
import logo from './images/comptia_logo.png';

interface IRibbonProps {
}

interface IRibbonState {
}

export default class Ribbon extends React.PureComponent<IRibbonProps, IRibbonState> {
    static contextType = AppContext;
    constructor(props: IRibbonProps) {
        super(props);
        this.state = { showCertSelectorPopup: false };
    }

    render() {
        let context = this.context as IAppContext | undefined;
        let showUser = context != null && context.user != null && window.location.pathname.match(/managecert/i) != null;

        return (
            <div className="ribbon">
                <img src={logo} alt="TestOut Logo" width="112px" height="24" />
                <span>Verification Center</span>
                {showUser && <span>{context?.user?.givenName} {context?.user?.surname}</span>}
            </div>
        );
    }
}